(function () {
  window.ciwFirst30CardPricing = {
    isEligible: function (product) {
      if (!product) return false;
      if (product.type === 'Contact Lenses' || product.type === 'LensAdvizor') return false;
      var vendor = (product.vendor || '').toLowerCase().replace(/\s+/g, '-');
      if (vendor === 'ray-ban' || vendor === 'dita' || vendor.indexOf('ray-ban') !== -1) return false;
      var tags = product.tags || [];
      if (typeof tags === 'string') tags = tags.split(',');
      for (var i = 0; i < tags.length; i++) {
        if (String(tags[i]).trim().toLowerCase() === 'no-sale') return false;
      }
      return true;
    },

    isDismissed: function () {
      return window.ciwFirst30Dismissed === true;
    },

    shouldShow: function (product) {
      return this.isEligible(product) && !this.isDismissed();
    },

    listPriceCents: function (variant) {
      if (!variant) return 0;
      var price = variant.price || 0;
      var compareAt = variant.compare_at_price;
      if (compareAt && compareAt > price) {
        var ratio = (price * 100) / compareAt;
        if (ratio >= 68 && ratio <= 72) return compareAt;
      }
      return price;
    },

    salePriceCents: function (variant) {
      var list = this.listPriceCents(variant);
      return Math.round((list * 7) / 10);
    },

    formatMoney: function (cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var format =
          (window.theme && window.theme.moneyFormat) ||
          (window.Shopify.theme && window.Shopify.theme.moneyFormat) ||
          '${{amount}}';
        return Shopify.formatMoney(cents, format);
      }
      return '$' + (cents / 100).toFixed(2);
    },

    appendCardPrices: function (priceWrap, product, variant) {
      if (!priceWrap || !variant) return;

      if (this.shouldShow(product)) {
        var list = this.listPriceCents(variant);
        var sale = this.salePriceCents(variant);
        var msrpEl = document.createElement('span');
        msrpEl.className = 'ciw-card__msrp';
        msrpEl.textContent = this.formatMoney(list);
        priceWrap.appendChild(msrpEl);
        priceWrap.appendChild(document.createTextNode(' '));
        var nowEl = document.createElement('span');
        nowEl.className = 'ciw-card__now';
        nowEl.textContent = this.formatMoney(sale);
        priceWrap.appendChild(nowEl);
        return;
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var compareEl = document.createElement('span');
        compareEl.className = 'ciw-card__msrp';
        compareEl.textContent = this.formatMoney(variant.compare_at_price);
        priceWrap.appendChild(compareEl);
        priceWrap.appendChild(document.createTextNode(' '));
      }

      if (variant.price) {
        var priceEl = document.createElement('span');
        priceEl.className = 'ciw-card__now';
        priceEl.textContent = this.formatMoney(variant.price);
        priceWrap.appendChild(priceEl);
      }
    }
  };
})();
